import * as React from 'react'

import './Projects.css'

interface ProjectProps {
  language: string
  title: string
  about: string
  link: string
}

// ProjectsCard is now the component which will take the array of repos from the GitHub API pulled when the overall Project component loads
const ProjectsCard: React.ElementType = (props: ProjectProps) => {
  // Destruct our props
  const { language, title, about, link } = props
  // Pull the image from props and assign an image for the card based on it's language
  var image
  switch (language) {
    case 'JavaScript':
      image = require('../../img/javascript.jpg')
      break
    case 'Python':
      image = require('../../img/python.png')
      break
    case 'TypeScript':
      image = require('../../img/typescript.png')
      break
    default:
      image = require('../../img/github.jpeg')
      break
  }
  return (
    <div className="col col-lg-4 col-md-10 col-sm-12 col-12 mt-4">
      <div className="project-card">
        <img className="card-img-top" height="300" width="250" alt="logo" src={image}/>
        <div className="card-body">
          <h5 className="card-title">{title}</h5>
          <p className="card-text">{about}</p>
          <div id="footer-link">
            <i className="fa fa-github fa-2x m-2" aria-hidden="true"></i>
            <a href={link} className="btn" role="button">Github Repository</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProjectsCard
